<h1>Administration</h1>

<router-outlet name="sidenav"></router-outlet>

<router-outlet></router-outlet>